import React, { useState } from "react"
import { X } from "@phosphor-icons/react"
import { cn } from "../../../lib/utils"
import { sendDigits } from "../../../lib/twilio"

interface DTMFKeypadProps {
  onClose: () => void
}

const keys = [
  { digit: "1", letters: "" },
  { digit: "2", letters: "ABC" },
  { digit: "3", letters: "DEF" },
  { digit: "4", letters: "GHI" },
  { digit: "5", letters: "JKL" },
  { digit: "6", letters: "MNO" },
  { digit: "7", letters: "PQRS" },
  { digit: "8", letters: "TUV" },
  { digit: "9", letters: "WXYZ" },
  { digit: "*", letters: "" },
  { digit: "0", letters: "+" },
  { digit: "#", letters: "" },
]

export function DTMFKeypad({ onClose }: DTMFKeypadProps) {
  const [digits, setDigits] = useState("")

  const handleKeyPress = (digit: string) => {
    setDigits((prev) => prev + digit)
    sendDigits(digit)
  }

  return (
    <div className="absolute inset-0 z-10 bg-sidebar-dark/95 backdrop-blur-sm rounded-xl p-3 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-white/60">
          Keypad
        </span>
        <button
          onClick={onClose}
          className="p-1 rounded-full hover:bg-white/10 transition-colors"
        >
          <X className="h-4 w-4 text-white/60" />
        </button>
      </div>

      {/* Digits display */}
      <div className="h-8 flex items-center justify-center mb-3 bg-white/5 rounded-lg">
        <span className="text-lg font-mono text-white tracking-wider">
          {digits || "\u00A0"}
        </span>
      </div>

      {/* Keypad grid */}
      <div className="grid grid-cols-3 gap-2 flex-1">
        {keys.map(({ digit, letters }) => (
          <button
            key={digit}
            onClick={() => handleKeyPress(digit)}
            className={cn(
              "flex flex-col items-center justify-center rounded-xl",
              "bg-white/10 hover:bg-white/20 active:bg-white/30",
              "transition-all duration-100 active:scale-95"
            )}
          >
            <span className="text-lg font-bold text-white">{digit}</span>
            {letters && (
              <span className="text-[8px] text-white/50 tracking-widest">
                {letters}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
